export { default as tempReducer } from './temp.reducer'
